"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFPClient = void 0;
const ClientProxy_1 = require("./ClientProxy");
/**
 * Creates an instance of RFP Client
 *
 * This is used to do all the request relative to RFP API.
 *
 * @public
 */
class RFPClient {
    /**
     * Creates an instance of RFP Client.
     *
     * The constructor will create an instance of the ProxyClient classes:
     * - The clientProxy instance is created with the apiBaseURLProxy, domainKey, and headerRefererOverride parameters.
     *
     * Since the API call of RFP have been migrated to the Proxy, in true, this is the clientProxy who do the call.
     * But for use clarity, the call have been split into different classes.
     *
     * @param apiBaseURLProxy - The base URL of the proxy.
     * @param domainKey - The domain key for the proxy.
     * @param headerRefererOverride - This is a OPTIONAL parameter: header referer override for the proxy. (use case: when you want to change the referer for local developpement)
     *
     * @remarks
     * The parameters `headerRefererOverride` must only be use for local developpement.
     */
    constructor(apiBaseURLProxy, domainKey, headerRefererOverride) {
        this.apiBaseURLProxy = apiBaseURLProxy;
        this.domainKey = domainKey;
        this.headerRefererOverride = headerRefererOverride;
        this.clientProxy = new ClientProxy_1.ProxyClient(this.apiBaseURLProxy, this.domainKey, this.headerRefererOverride);
    }
    /**
     * Make an API call for a meeting
     *
     * @param body - structure RequestMeeting contain information for the request
     *
     * @internal
     */
    apiCallMeeting(body) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.clientProxy.apiRFPMeeting(body);
        });
    }
    /**
     * Make an API call to post a meeting
     *
     * @param body - structure RequestMeeting contain information for the request
     *
     * @returns a empty promise (aka nothing) since the API call return nothing too
     *
     * @throws `Error` class contain information about the failed request
     *
     * @remarks This fields are required:
     * - Rfps[].MeetingID
     * - Rfps[].MeetingInfo.meetingName
     * - Rfps[].Sites[].locationsIdentifier
     *
     * @example How to Use
     *
     * ```typescript
     * let client = new RFPClient(BASE_URL_PROXY, DOMAIN_KEY)
     * client.postMeeting({
     *  "rfps": [...],
     * }).then((empty) => {
     *     ....
     * }).catch((error) => {
     *     console.log(error)
     * })
     * ```
     */
    postMeeting(body) {
        return __awaiter(this, void 0, void 0, function* () {
            // Use the call for Call Meeting API
            yield this.apiCallMeeting(body);
        });
    }
}
exports.RFPClient = RFPClient;
//# sourceMappingURL=ClientRFP.js.map